import { render, staticRenderFns } from "./MsgErroFormularios.vue?vue&type=template&id=644648d8&scoped=true&"
import script from "./MsgErroFormularios.vue?vue&type=script&lang=js&"
export * from "./MsgErroFormularios.vue?vue&type=script&lang=js&"
import style0 from "./MsgErroFormularios.vue?vue&type=style&index=0&id=644648d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644648d8",
  null
  
)

export default component.exports